import { captureException } from '@sentry/react';
import { MESSAGE_TYPE } from '../../constants/MessageTypes';
import { VIDEO_STATUS } from '../../constants/videoStatus';
import { byKey } from '../../helper/byKey';
import { openErrorDialog } from '../../slices/errorDialogSlice/errorDialogSlice';
import addMessages from '../../slices/messages/messagesThunks/addMessages';
import { updateVideoUploadProgress } from '../../slices/videos/videosSlice';
import FatalQueueError from '../errors/FatalQueueError';

const sendMessageEffect = async (_effect, action, { gccApiClient, videoClient, dispatch }) => {
  let { messages } = action.meta;
  messages = await Promise.all(
    messages.map(async (message) => {
      if (message.isForwarded) {
        return message;
      }

      if (message.messageType === MESSAGE_TYPE.MEDIA) {
        const { fileToUpload: file, filename } = message;
        try {
          const { imageUrl } = await gccApiClient.uploadMessageMedia(filename, file);

          const baseUrl = import.meta.env.VITE_MEDIA_BASE_URL?.replace(/\/$/, '');
          let mediaRelativePath = imageUrl;

          try {
            const parsedUrl = new URL(imageUrl);
            const trimmedPath = parsedUrl.pathname.replace(/^\//, '');

            if (baseUrl && imageUrl.startsWith(`${baseUrl}/`)) {
              mediaRelativePath = parsedUrl.pathname.split('/').pop();
            } else {
              mediaRelativePath = trimmedPath;
            }
          } catch (_e) {
            if (baseUrl && imageUrl.startsWith(`${baseUrl}/`)) {
              mediaRelativePath = imageUrl
                .substring(baseUrl.length + 1)
                .split('/')
                .pop();
            }
          }

          return {
            ...message,
            mediaRelativePath,
          };
        } catch (e) {
          dispatch(
            openErrorDialog({
              dialogErrorMsg: 'Beim Hochladen der Datei ist ein Fehler aufgetreten, bitte versuche es noch einmal.',
            }),
          );
          captureException(e);
          throw new FatalQueueError('An error occurred while uploading the media file to storage!', {
            e,
            clientMessageId: message.clientMessageId,
          });
        }
      } else if (message.messageType === MESSAGE_TYPE.VIDEO) {
        try {
          const { fileToUpload, videoId } = message;
          const muxUploadVideoId = await videoClient.upload(fileToUpload, (progress) => {
            dispatch(updateVideoUploadProgress({ videoId, percentage: progress }));
          });

          return {
            ...message,
            videoId: muxUploadVideoId,
            videoStatus: VIDEO_STATUS.PROCESSING,
          };
        } catch (e) {
          dispatch(
            openErrorDialog({
              dialogErrorMsg: 'Beim Hochladen des Videos ist ein Fehler aufgetreten, bitte versuche es noch einmal.',
            }),
          );
          captureException(e);
          throw new FatalQueueError('An error occured while uploading the Video to the video client!', {
            e,
            clientMessageId: message.clientMessageId,
          });
        }
      }
      return message;
    }),
  );

  const sentMessages = await gccApiClient.sendChannelMessages(messages);
  dispatch(addMessages({ channelMessages: byKey('channelId', sentMessages, true) }));
};

export default sendMessageEffect;
